import { Box, BoxProps, CircularProgress, CircularProgressProps } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
interface CircularLoading {
  boxProps?: BoxProps;
  circularProgressProps?: CircularProgressProps;
}
export const CircularLoading = ({ boxProps, circularProgressProps }: CircularLoading) => {
  return (
    <Box mt={3} display={'flex'} width={'100%'} flexDirection={'column'} alignItems={'center'} {...boxProps}>
      <CircularProgress size={32} color="secondary" style={{ marginBottom: '6px' }} {...circularProgressProps} />
      <Font variant="body2" color="textSecondary">
        <Text tId={'LOADING'} />
        {'...'}
      </Font>
    </Box>
  );
};
